import Component from '../abstracts/Component';

export default class FiltersMobileCollapseComponent extends Component {
    
    get SELECTORS() {
        return {
            main: '[data-filters-collapse]',
            filterColumns: '[data-filters-column]',
            arrowIcon : '[class^="icon-arrow-"]',
        };
    }
    
    constructor() {
        super();
        this.rotateClassIcon= 'rotate';
    }
    rotateTriggerIcon(trigger){
        let icon = trigger.querySelector(this.SELECTORS.arrowIcon);
        icon.classList.toggle(this.rotateClassIcon);
    }
    toggleFiltersColumn(dataColumn){
        let column = document.querySelector(`[data-filters-column=${dataColumn}]`);
        column.classList.toggle('show');
    }
    filtersCollapseHandler(){
        let triggers = document.querySelectorAll(this.SELECTORS.main);
        for(let trigger of triggers){
            trigger.addEventListener('click',()=>{
                let dataColumn = trigger.dataset.filtersCollapse;
                this.rotateTriggerIcon(trigger);
                this.toggleFiltersColumn(dataColumn);
            })
        }
    }
    render() {
        if (document.querySelectorAll(this.SELECTORS.main)) {
            this.filtersCollapseHandler();
        }
        let myName = this.constructor.name
        console.log(`[${myName}] Rendering..`);
    }
}
